var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-popup",class:[ _vm.popupSizeClass ]},[_c('div',{staticClass:"c-popup__backdrop",on:{"click":_vm.handleClose}}),_c('div',{staticClass:"c-popup__content"},[_c('button',{staticClass:"c-popup__close c-button c-button--close",on:{"click":_vm.handleClose}},[_vm._v("\n            ×\n        ")]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }